import { render } from "./Headers.vue?vue&type=template&id=c24db1ee&scoped=true"
import script from "./Headers.vue?vue&type=script&lang=js"
export * from "./Headers.vue?vue&type=script&lang=js"

import "./Headers.vue?vue&type=style&index=0&id=c24db1ee&scoped=true&lang=css"

import exportComponent from "/vercel/path0/shinai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24db1ee"]])

export default __exports__